import { Component } from '@angular/core';

@Component({
  selector: 'ov-suite-load-loader',
  template: '<mat-progress-bar mode="indeterminate"></mat-progress-bar>',
})
export class LoadAllocationLoaderComponent {}
